import {  Button, Heading, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  return (
    <VStack mt="3rem" ml="10.6rem" mr="12.06rem" gap="0.75rem">
      <Heading as="h1" mb="4">
        404 - Not Found
      </Heading>
      <Text mb="4">
        Sorry, the page you are looking for doesn't exist or you may
        not be authorized to access it.
      </Text>
      <Button as={Link} to="/" colorScheme="blue">
        Go to Home
      </Button>
    </VStack>
  );
};

export default NotFoundPage;
